export default __webpack_public_path__ + "static/media/m-serviceInfo1.44bbcab7.png";